export const environment = {
  production: false,
  apiUrl: 'https://hom.orcamento.es.gov.br/participe',
  defaultConference: '664',
  siteKey: '6LccLN0gAAAAAOE5I31MWY1JcUJzuXeDDDz3S5QP',
  logoutURIAcessoCidadao: 'https://acessocidadao.es.gov.br/is/logout',
  logoutURIGoogle: 'https://www.google.com/accounts/Logout?continue=https://appengine.google.com/_ah/logout',
  logoutURIFacebook: 'https://www.facebook.com/logout.php',
};